import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
import { useCartStore } from '../store/cartStore';
import { HEADER } from '../constants/testIds';

const Header = ({ onCartClick }) => {
  const itemCount = useCartStore(state => state.getItemCount());
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  return (
    <motion.header 
      data-testid={HEADER.navigation}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#FDFBF7]/90 border-b border-[#E5DEC5] shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Left spacer to balance layout */}
          <div className="flex-1" />
          
          {/* Navigation - Centered */}
          <nav className="hidden md:flex items-center gap-8">
            <motion.button
              onClick={scrollToTop}
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.95 }}
              className="text-[#142A1D] hover:text-[#B58A3F] transition-colors text-sm font-medium tracking-wide relative group"
              data-testid={HEADER.logo}
            >
              INICIO
              <motion.span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#B58A3F] group-hover:w-full transition-all duration-300" />
            </motion.button>
            {[
              { label: 'NUESTRO CAFÉ', id: 'cafe' },
              { label: 'NUESTRA HISTORIA', id: 'historia' },
              { label: 'CONTACTO', id: 'contacto' }
            ].map((item) => (
              <motion.button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="text-[#142A1D] hover:text-[#B58A3F] transition-colors text-sm font-medium tracking-wide relative group"
              >
                {item.label}
                <motion.span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#B58A3F] group-hover:w-full transition-all duration-300" />
              </motion.button>
            ))}
          </nav>
          
          {/* Right side with cart - flex-1 to balance */}
          <div className="flex-1 flex justify-end">
            <motion.button
              data-testid={HEADER.cartIcon}
              onClick={onCartClick}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="relative p-3 hover:bg-[#F2EBE1] rounded-xl transition-colors"
            >
              <ShoppingCart className="w-6 h-6 text-[#142A1D]" strokeWidth={1.5} />
              {itemCount > 0 && (
                <motion.span 
                  data-testid={HEADER.cartBadge}
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="absolute -top-1 -right-1 bg-[#B58A3F] text-white text-xs w-6 h-6 rounded-full flex items-center justify-center font-medium shadow-lg"
                >
                  {itemCount}
                </motion.span>
              )}
            </motion.button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
